exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-046592dc]{width:50%;border-collapse:collapse;border-left:1px solid #ccd0d4;border-right:1px solid #ccd0d4;border-bottom:1px solid #ccd0d4}table thead th[data-v-046592dc]{border-top:1px solid #ccd0d4;border-bottom:1px solid #ccd0d4;font-weight:400;color:#32373c;background-color:#fff;padding:.5rem;text-align:left}table td[data-v-046592dc]{padding:.5rem}table tr[data-v-046592dc]:nth-child(odd){background-color:#f9f9f9}table tr[data-v-046592dc]:nth-child(2n){background-color:#fff}.edit-button[data-v-046592dc]{cursor:pointer}.edit-button[data-v-046592dc]:hover{color:orange}.delete-button[data-v-046592dc]{cursor:pointer}.delete-button[data-v-046592dc]:hover{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-046592dc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/Plans.vue
// module id = 96
// module chunks = 0